import { Component } from '@angular/core';
import { Subscription } from 'rxjs';

// Services
import { LoginService } from 'src/app/services/login/login.service';
import { LoginInvitedService } from 'src/app/services/login-invited/login-invited.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {

  listSubcriptions: Subscription[] = [];

  showLogin: boolean = false;
  showLoginInvited: boolean = false;

  constructor(
    private _loginService: LoginService,
    private _loginInvitedService: LoginInvitedService
  ){ }

  ngOnInit(): void {
    this.listenerShowLogin();
    this.listenerShowLoginInvited();
  }

  ngOnDestroy(): void {
    this.listSubcriptions.forEach((sub: Subscription) => { if (sub) sub.unsubscribe(); });
  }

  listenerShowLogin(): void {
    this.listSubcriptions.push(
      this._loginService.getSubjetShowLogin().asObservable().subscribe(
        data => {
          this.showLogin = data;
        }
      )
    );
  }

  listenerShowLoginInvited(): void {
    this.listSubcriptions.push(
      this._loginInvitedService.getSubjetShowLogin().asObservable().subscribe(
        data => {
          console.log('hola');
          
          this.showLoginInvited = data;
        }
      )
    );
  }

}
